import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';
import { useGetFcpsCourseListsMutation } from 'src/rtk/features/trainee/traineeFcpsCourseListApi';
import loader from '../../assets/images/loader.gif';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CourseListApplyModal from './CourseListApplyModal';
import CourseListViewDetailsModal from './CourseListViewDetailsModal';

const CourseList = () => {

  const [courseName, setCourseName] = useState<string>('');
  const [courseList, setCourseList] = useState<FcpsCourseList>({});
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [courseListModalShow, setCourseListModalShow] = useState<boolean>(false);
  const [fcpsCourseList, setFcpsCourseList] = useState<FcpsCourseList[] | null>(null);

  const [createFcpsCourse, { data: fcpsCourseListData, isSuccess, isError, error, isLoading }] =
    useGetFcpsCourseListsMutation();

  // const { data: supervisorList } = useGetSupervisorsQuery();  
  // const supervisors = supervisorList?.data || [];

  const modalShowHandler = (modalState: boolean, courseList: FcpsCourseList) => {
    setModalShow(modalState);
    setCourseList(courseList);
  };

  const courseListModalShowHandler = (modalState: boolean, courseName: string) => {
    setCourseListModalShow(modalState);
    setCourseName(courseName);
  };

  const err: CustomError = error as CustomError;

  useEffect(() => {
    createFcpsCourse('main-training');
  }, []);

  useEffect(() => {
    if (isSuccess && fcpsCourseListData?.success) {
      const updatedCourseList = fcpsCourseListData?.data?.filter((item) => item.name !== 'FCPS part -1' && item.name !== 'MCPS');
      setFcpsCourseList(updatedCourseList!);
    }
    if (isError) {
      toast.error(err?.message || 'Something went wrong');
    }
  }, [isSuccess, isError, fcpsCourseListData?.success]);

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading ? (
          <div className="overlay">
            <img src={loader} alt="Loading" height={100} width={300} />
          </div>
        ) : null}
        <div className="container-fluid">
          <Breadcrumbs title="Enrollment" breadcrumbItem="Apply" />
          {
            fcpsCourseList?.length === 0 ? (
              <Alert color="danger">Your Registration Under Review!</Alert>
            ) : (
              <Row>


                {
                  fcpsCourseList?.map((course: FcpsCourseList, index: number) => {
                    return (
                      <Col className='col-lg-3 col-md-4' key={index}>
                        <Card>
                          <CardBody className='text-center'>
                            <svg width="104" height="91" viewBox="0 0 104 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M-1.10469e-05 51.9084C-1.35531e-05 23.2402 23.2402 7.04424e-06 51.9084 4.53798e-06C80.5767 2.03172e-06 103.817 23.2402 103.817 51.9084C103.817 80.5766 91.7915 91 63.1232 91C34.455 91 -8.54064e-06 80.5766 -1.10469e-05 51.9084Z" fill="url(#paint0_linear_824_133)" fillOpacity="0.5" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M49.8545 24.5502C48.7075 25.175 47.8809 26.6907 47.853 28.2195C47.8327 29.3335 47.7372 29.4039 43.3894 31.5023L38.9461 33.6466L38.0404 32.8037C36.2757 31.1621 33.144 31.258 31.4014 33.0073C28.7506 35.668 30.1863 40.5518 33.7892 41.13C34.9029 41.3087 35.1545 41.5051 35.3367 42.3372C35.4872 43.0252 35.7643 43.3312 36.2362 43.3312C36.7968 43.3312 36.8989 43.1346 36.8102 42.2248C36.7215 41.3125 36.9384 40.8978 38.0445 39.8652C39.2132 38.7739 39.4084 38.3709 39.5538 36.7452L39.7209 34.8783L43.9356 32.8448C46.4943 31.6099 48.3745 30.8975 48.7213 31.031C49.4008 31.2925 49.6758 30.8074 45.2002 37.2379C41.8932 41.9888 41.2796 43.3457 42.4493 43.3226C42.6913 43.3178 44.5911 40.8357 46.6706 37.8072C48.7501 34.7786 50.6451 32.2983 50.8812 32.2955C51.1951 32.292 51.3109 33.1736 51.3109 35.5683C51.3109 38.6159 51.359 38.846 51.9983 38.846C52.6377 38.846 52.6858 38.6159 52.6858 35.5683C52.6858 33.1736 52.8016 32.292 53.1154 32.2955C53.3519 32.2983 55.2465 34.7786 57.3261 37.8072C59.7479 41.3343 61.3232 43.3167 61.7085 43.3226C62.0396 43.3274 62.3101 43.0942 62.3101 42.8044C62.3101 42.5146 60.6169 39.8421 58.5473 36.8659C55.8233 32.9483 54.8812 31.3377 55.1341 31.0317C55.4012 30.7091 56.5224 31.1138 59.8779 32.7437L64.2717 34.8783L64.4408 36.7452C64.5879 38.3695 64.7845 38.7749 65.9522 39.8652C67.0583 40.8978 67.2752 41.3125 67.1865 42.2248C67.0978 43.1346 67.1999 43.3312 67.7605 43.3312C68.2324 43.3312 68.5095 43.0252 68.66 42.3372C68.8401 41.5133 69.0965 41.3084 70.159 41.1376C72.012 40.8402 73.6805 39.0085 73.9028 37.0267C74.2129 34.2676 72.5369 32.0536 69.8658 31.6941C68.1145 31.4581 67.0947 31.7448 65.9735 32.7878L65.0506 33.6466L60.6073 31.5023C56.2595 29.4039 56.1639 29.3335 56.1437 28.2195C56.0842 24.938 52.7329 22.9828 49.8545 24.5502ZM53.7434 26.3988C54.2961 26.9536 54.7481 27.7416 54.7481 28.1505C54.7481 29.111 52.9553 30.9106 51.9983 30.9106C51.0414 30.9106 49.2485 29.111 49.2485 28.1505C49.2485 27.1899 51.0414 25.3903 51.9983 25.3903C52.4057 25.3903 53.1907 25.844 53.7434 26.3988ZM37.2103 34.1965C38.4305 35.4207 38.3917 37.4801 37.1244 38.7518C35.049 40.835 31.5622 39.3977 31.5622 36.4585C31.5622 33.3795 35.0167 31.996 37.2103 34.1965ZM71.5827 34.1965C72.8029 35.4207 72.7641 37.4801 71.4968 38.7518C69.4214 40.835 65.9346 39.3977 65.9346 36.4585C65.9346 33.3795 69.3891 31.996 71.5827 34.1965ZM46.7349 41.1938C45.8144 42.1582 45.8113 42.1799 45.8113 47.4601C45.8113 52.4742 45.857 52.8368 46.6613 54.2148C47.1291 55.0156 47.7863 55.7781 48.1222 55.9089C48.6006 56.0955 48.3463 56.3322 46.947 57.0022C43.4021 58.699 40.7256 62.676 40.5516 66.5043C40.4929 67.7926 40.5788 68 41.171 68C41.7423 68 41.8953 67.6971 42.0764 66.2076C42.7319 60.8167 47.1192 57.212 52.6287 57.538C57.5581 57.8296 61.3322 61.3729 61.9275 66.2677C62.1018 67.6995 62.2575 68 62.8256 68C63.4323 68 63.5024 67.7999 63.4234 66.2977C63.2374 62.7671 60.4498 58.6814 57.1769 57.1426C55.5335 56.3701 55.4799 56.3032 56.132 55.8447C56.5104 55.5787 57.127 54.7568 57.5024 54.0178C58.0953 52.8513 58.1854 51.9815 58.1854 47.418C58.1854 42.1834 58.1816 42.1575 57.2618 41.1938C56.3454 40.2337 56.3045 40.2261 51.9983 40.2261C47.6922 40.2261 47.6513 40.2337 46.7349 41.1938ZM56.2753 42.3731C56.5695 42.7947 56.8105 43.7263 56.8105 44.4432V45.7464H51.9983H47.1862V44.3073C47.1862 41.9018 47.7169 41.6061 52.032 41.6061C55.4744 41.6061 55.7786 41.661 56.2753 42.3731ZM34.7853 45.4282C34.1233 46.0928 34.0793 46.4678 34.1838 50.5683C34.2801 54.3394 34.3935 55.0988 34.9534 55.7187C35.3143 56.119 35.5463 56.4899 35.469 56.543C35.3913 56.5961 34.6826 57.0736 33.8941 57.6039C31.6392 59.1203 30 62.066 30 64.6012C30 65.4845 30.1461 65.7574 30.6187 65.7574C31.0992 65.7574 31.3336 65.2892 31.6691 63.6583C32.6721 58.7842 37.4471 56.3477 42.1135 58.3295C42.9959 58.7042 43.3581 57.5128 42.5435 56.9149C41.9348 56.4681 41.9358 56.4288 42.5738 55.7222C43.1371 55.0981 43.2499 54.347 43.3461 50.5683C43.4932 44.7903 43.4314 44.7113 38.765 44.7113C35.9172 44.7113 35.4082 44.8031 34.7853 45.4282ZM61.2521 45.4282C60.5901 46.0928 60.5461 46.4678 60.6506 50.5683C60.7461 54.3183 60.862 55.1008 61.4116 55.7098C62.0495 56.416 62.0468 56.4385 61.2397 57.1002C60.6275 57.6025 60.5179 57.8737 60.808 58.1701C61.1008 58.4696 61.591 58.433 62.7964 58.0221C64.8031 57.3383 65.5651 57.339 67.5756 58.0266C69.8988 58.8211 71.8003 61.0965 72.3423 63.7308C72.6647 65.2971 72.8999 65.7574 73.378 65.7574C74.2813 65.7574 74.1861 63.5914 73.1879 61.4447C72.442 59.8403 70.4787 57.7002 68.9811 56.8587C68.3582 56.5092 68.3596 56.4764 69.0199 55.745C69.6084 55.0932 69.7153 54.396 69.8129 50.5683C69.96 44.7903 69.8981 44.7113 65.2317 44.7113C62.384 44.7113 61.8749 44.8031 61.2521 45.4282ZM41.6179 46.5054C41.8447 46.7331 42.0303 47.3541 42.0303 47.8855V48.8515H38.765H35.4996V47.8855C35.4996 47.3541 35.6852 46.7331 35.9121 46.5054C36.4596 45.9558 41.0703 45.9558 41.6179 46.5054ZM68.0846 46.5054C68.3115 46.7331 68.4971 47.3541 68.4971 47.8855V48.8515H65.2317H61.9663V47.8855C61.9663 47.3541 62.1519 46.7331 62.3788 46.5054C62.9264 45.9558 67.5371 45.9558 68.0846 46.5054ZM56.8105 49.3801C56.8105 53.2874 55.3483 55.3875 52.4393 55.6598C49.2039 55.962 47.1876 53.5803 47.1869 49.4553L47.1862 47.1264H51.9983H56.8105V49.3801ZM42.0303 51.7617C42.0303 53.9378 41.5313 54.9828 40.1839 55.6277C38.8681 56.2577 37.72 56.0979 36.5139 55.1174C35.8849 54.6064 35.6914 54.0395 35.5697 52.3531L35.4171 50.2316H38.7237H42.0303V51.7617ZM68.4971 51.7617C68.4971 53.9378 67.998 54.9828 66.6506 55.6277C65.3348 56.2577 64.1868 56.0979 62.9807 55.1174C62.3517 54.6064 62.1581 54.0395 62.0365 52.3531L61.8838 50.2316H65.1905H68.4971V51.7617Z" fill="#303030" />
                              <defs>
                                <linearGradient id="paint0_linear_824_133" x1="51.9084" y1="64.6499" x2="51.9084" y2="1.8025e-05" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#C7D2FE" />
                                  <stop offset="1" stopColor="#D0E0FF" />
                                </linearGradient>
                              </defs>
                            </svg>

                            <h4 className="py-3"> {course.name} </h4>
                            <div className='card-button-group'>
                              <a
                                type="button"
                                className="btn btn-link"
                                target='_blank'
                                href='/documents/Eligibility criteria for 05 year fellowship program.pdf'
                              >
                                Details
                              </a>
                              {
                                course.active_course || course.name === 'FCPS part -1' ? (
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => modalShowHandler(true, course!)}
                                    disabled
                                  >
                                    Apply
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => modalShowHandler(true, course!)}
                                  >
                                    Apply
                                  </button>
                                )
                              }
                            </div>


                          </CardBody>
                        </Card>
                      </Col>
                    )
                  })
                }
                {modalShow ? (
                  <CourseListApplyModal
                    isOpen={modalShow}
                    toggle={() => setModalShow(!modalShow)}
                    courseList={courseList}
                  />
                ) : null}
                {courseListModalShow ? (
                  <CourseListViewDetailsModal
                    isOpen={courseListModalShow}
                    toggle={() => setCourseListModalShow(!courseListModalShow)}
                    courseName={courseName}
                  />
                ) : null}



              </Row>
            )
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default CourseList;
